import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { TipologiaMezzo } from '../../core/models/garage.model';

export const TipologieMezziActions = createActionGroup({
  source: 'TipologieMezzi',
  events: {
    'Load List': emptyProps(),
    'Load List Success': props<{ items: TipologiaMezzo[] }>(),
    'Load List Failure': props<{ error: string }>(),

    'Create': props<{ tipo: string }>(),
    'Create Success': props<{ id: number }>(),
    'Create Failure': props<{ error: string }>(),

    'Delete': props<{ id: number }>(),
    'Delete Success': props<{ id: number }>(),
    'Delete Failure': props<{ error: string }>(),
  },
});
